import React, {Component, createRef} from 'react';
import Form from './form';
import Markdown from './markdown';
import {getLocationLabel} from './locations';
import Loading from './loading';
import request from '../request';
import {calculateDistance} from './geolocation';

import {TrialSearchKey, TrialLocationSearchKey} from '../constants.js.erb';
export default class ChatUserResultsEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.modalRef = createRef();

    this.closeForm = this.closeForm.bind(this);
    this.changeResultSummary = this.changeResultSummary.bind(this);
    this.submitResultSummary = this.submitResultSummary.bind(this);
    this.changePatientSummary = this.changePatientSummary.bind(this);
    this.submitPatientSummary = this.submitPatientSummary.bind(this);
    this.submitNewTherapy = this.submitNewTherapy.bind(this);
    this.setCustomLocation = this.setCustomLocation.bind(this);
  }

  componentDidMount() {
    this.fetchResults();
    this.modalEl = $(this.modalRef.current);
    this.modalEl.modal({show: false, backdrop: 'static'});
    this.modalEl.on('hide.bs.modal', () => {
      this.setState({show_modal: false, modal_content: undefined});
    });

  }

  fetchResults() {
    this.setState({loading: true});
    let {chat_user_session} = this.props;
    let url = `/admin/chat_user_sessions/${chat_user_session.id}/results`;
    request('GET', url).then(report => {
      this.setState({report, loading: false});
    });
  }

  submitPatientSummary(e) {
    e.preventDefault();
    this.closeForm()

    let {chat_user_session} = this.props;
    let {report, patient_summary_form} = this.state;
    let {patient_summary, rebuild} = patient_summary_form;
    report.patient_summary = patient_summary;
    this.submitReport(report, {rebuild});
  }

  submitResultSummary(e) {
    e.preventDefault();
    this.closeForm()

    let {report, result} = this.state;
    let index = report.results.findIndex(r => r.trial_id === result.trial_id);
    report.results[index] = result;
    this.submitReport(report);
  }

  submitReport(report, opt={}) {
    this.setState({loading: true});
    let {chat_user_session} = this.props;
    let url = `/admin/chat_user_sessions/${chat_user_session.id}/results`;
    return request('PUT', url, {report, rebuild: opt.rebuild}).then(report => {
      this.setState({report, loading: false});
    });

  }


  submitNewTherapy() {
    this.setState({loading: true});

    let {chat_user_session} = this.props;
    let {trial_id} = this.state;
    this.closeForm();

    let url = `/admin/chat_user_sessions/${chat_user_session.id}/results/add_therapy`;
    return request('PUT', url, {trial_id}).then(report => {
      this.setState({report, loading: false});
    });
  }


  moveUp(result) {
    let {report} = this.state;
    let index = report.results.findIndex(r => r.trial_id === result.trial_id);
    if (index === 0) return;
    report.results.splice(index, 1);
    report.results.splice(index - 1, 0, result);
    this.submitReport(report);
  }

  moveDown(result) {
    let {report} = this.state;
    let index = report.results.findIndex(r => r.trial_id === result.trial_id);
    if (index === report.results.length - 1) return;
    report.results.splice(index, 1);
    report.results.splice(index + 1, 0, result);
    this.submitReport(report);
  }

  setCustomLocation(trial_location) {
    let {result} = this.state;
    if (trial_location.option === undefined) {
      delete result.custom_geolocation;
      this.setState({result});
      return;
    }

    let {chat_data} = this.props.chat_user_session;
    let cancer_center = trial_location.option.cancer_centers[0];
    let distance = Math.round(calculateDistance(chat_data.patient_location, cancer_center));
    result.custom_geolocation = {distance, cancer_center};
    this.setState({result});
  }

  closeForm() {
    this.modalEl.modal('hide')
    this.setState({show_modal: false, modal_content: undefined})
  }

  changePatientSummary(patient_summary_form) {
    this.setState(patient_summary_form);
  }

  changeResultSummary(summary) {
    let {result} = this.state;
    result.summary = summary;
    this.setState({result});
  }


  deleteResult(result) {
    if (!window.confirm('Are you sure?')) return;
    let {report} = this.state;
    let index = report.results.findIndex(r => r.trial_id === result.trial_id);
    report.results.splice(index, 1);
    this.submitReport(report);
  }


  openPatientSummaryEditor() {
    let {report} = this.state;
    let patient_summary_form = {patient_summary: report.patient_summary, rebuild: true};
    this.setState({patient_summary_form, show_modal: true, modal_content: 'patient_summary'}, () => {
      this.modalEl.modal('show')
    });
  }

  openResultEditor(result) {
    let summary = Object.assign({}, result.summary);
    result = Object.assign({}, result, {summary});
    this.setState({show_modal: true, modal_content: 'result_form', result}, () => {
      this.modalEl.modal('show')
    });
  }

  openNewTherapy() {
    this.setState({show_modal: true, modal_content: 'new_therapy'}, () => {
      this.modalEl.modal('show')
    });
  }

  renderModal() {
    return (
      <div className="modal fade" tabIndex="-1" role="dialog" ref={this.modalRef}>
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 className="modal-title">Edit Report</h4>
            </div>

            <div className="modal-body">
              {this.renderModalContent()}
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    );
  }


  renderModalContent() {
    let {show_modal, modal_content} = this.state;
    if (!show_modal) return null;
    if (modal_content === 'result_form') {
      return this.renderResultForm();
    } else if (modal_content === 'patient_summary') {
      return this.renderPatientSummaryForm();
    } else if(modal_content === 'new_therapy') {
      return this.renderNewTherapyForm();
    }
    return null;
  }

  renderPatientSummaryForm() {
    let {patient_summary_form} = this.state;
    let fields = [
      {name: 'patient_summary', type: 'text', required: true, autosize: true},
      {name: 'rebuild', label: 'Rebuild Report', type: 'bool'}
    ]

    return <Form model={patient_summary_form} submitLabel="Update Patient Summary" fields={fields} onChange={this.changePatientSummary} onSubmit={this.submitPatientSummary} onCancel={this.closeForm} />
  }

  renderResultForm() {
    let {result} = this.state;
    let {chat_data} = this.props.chat_user_session;

    let fields = [
      {name: 'headline', required: true},
      {name: 'summary', type: 'text', required: true, autosize: true}
    ]

    if (chat_data.use_patient_location) {
      let custom_location = {
        name: 'custom_location_id', type: 'slektr', label: "Custom Location", hint: "Use this field to overwrite the closest location",
        src: `/admin/trials/${result.trial_id}/locations/as_options`, search_key: TrialLocationSearchKey, onChangeCallback: this.setCustomLocation
      }

      fields.push(custom_location);
    }

    return <Form model={result.summary} submitLabel="Update Result" fields={fields} onChange={this.changeResultSummary} onSubmit={this.submitResultSummary} onCancel={this.closeForm} />
  }

  renderNewTherapyForm() {
    let {trial_id} = this.state;
    let fields = [
      {name: 'trial_id', label: 'New Therapy', type: 'remote-select2', src: "/admin/trials/as_options.json",
       search_key: TrialSearchKey,  showLink: true, linkTemplate: '/admin/trials/{id}'},

    ]

    return <Form model={{trial_id}} submitLabel="Add Therapy" fields={fields} onChange={e => this.setState(e)} onSubmit={this.submitNewTherapy} onCancel={this.closeForm} />
  }

  renderLocation(result) {
    if (result.expanded_access) return <p>Expanded Access</p>;
    let geolocation = result.custom_geolocation || result.geolocation;
    if (!geolocation) return null;

    let label = getLocationLabel(geolocation.cancer_center);
    let custom_el = result.custom_geolocation ? <span className="badge">Custom</span> : null;
    return (
      <div className="location_marker">
        <p>Nearest Location ({geolocation.distance} miles away) {custom_el}<br/>
          <b>{label}</b>
        </p>
      </div>
    )
  }

  renderReport() {
    let {loading, report} = this.state;
    if (!report || loading) return <Loading/>
    return (
      <div>
        <div className="chat_user_session_report_edit_header">
          <h4 className="chat_user_session_edit_section">Patient Summary</h4>
          <Markdown text={report.patient_summary} ignoreGfm={true} />
          <div className="user_report_edit_actions">
            <button className="btn btn-primary" onClick={e => this.openPatientSummaryEditor()}>Edit Patient Summary</button>
          </div>
        </div>

        <h3>Results</h3>
        <hr/>
        <button className="btn btn-success" onClick={e => this.openNewTherapy()}>Add Therapy</button>
        <hr/>
        <div>
          {report.results.map(result => {
            let link = '/admin/trials/' + result.trial_id;
            return (
              <div key={result.trial_id} className="chat_user_session_single_result">
              <h4>{result.trial_identifier} - {result.summary.headline} <a href={link} target="_blank"><span className="fa-solid fa-link"></span></a></h4>
                <Markdown text={result.summary.summary} />
                {this.renderLocation(result)}
                <div className="btn-group">
                  <button className="btn btn-default btn-sm" onClick={e => this.openResultEditor(result)}>Edit</button>
                  <button className="btn btn-default btn-sm" onClick={e => this.moveUp(result)}>Move up</button>
                  <button className="btn btn-default btn-sm" onClick={e => this.moveDown(result)}>Move Down</button>
                  <button className="btn btn-danger btn-sm" onClick={e => this.deleteResult(result)}>Delete</button>
                </div>
                <hr/>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="chat_user_report_editor_holder">
        <h2>Report Editor</h2>
        <p className="markdown-instructions">MARKDOWN: **<b>bold</b>** | *<i>italics</i>* | LINKS: [link text](https://site.com)</p>
        {this.renderReport()}
        {this.renderModal()}
      </div>
    )
  }
}
